export default () => ({
    src: '',
    nowPlaying: false,

    container: {
        [':class']: 'nowPlaying === true ? "--is-active" : ""',
    },

    player: {
        [':src']: 'src',
    },

    init() {
        this.src = this.$el.dataset.src
    },

    loadVideo() {
        let videoUrl = this.src
        let isYouTube = videoUrl.includes('https://www.youtube.com/embed/')

        this.active = videoUrl
        this.src = `${videoUrl}${isYouTube ? '?autoplay=1' : '&autoplay=1'}`
        this.nowPlaying = true
    },
})
